// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/stepup/v1/stepup.proto" (package "c1.api.stepup.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../../../google/protobuf/struct";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.stepup.v1.StepUpProviderRef
 */
export interface StepUpProviderRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.stepup.v1.StepUpProvider
 */
export interface StepUpProvider {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string issuer_url = 3;
     */
    issuerUrl: string;
    /**
     * @generated from protobuf field: string client_id = 4;
     */
    clientId: string;
    /**
     * @generated from protobuf field: bool enabled = 5;
     */
    enabled: boolean;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_tested_at = 8;
     */
    lastTestedAt?: Timestamp;
    /**
     * @generated from protobuf oneof: settings
     */
    settings: {
        oneofKind: "oauth2";
        /**
         * @generated from protobuf field: c1.api.stepup.v1.StepUpOAuth2Settings oauth2 = 101;
         */
        oauth2: StepUpOAuth2Settings;
    } | {
        oneofKind: "microsoft";
        /**
         * @generated from protobuf field: c1.api.stepup.v1.StepUpMicrosoftSettings microsoft = 102;
         */
        microsoft: StepUpMicrosoftSettings;
    } | {
        oneofKind: undefined;
    };
}
/**
 * StepUpOAuth2Settings repersents an OAuth2 provider that supports RFC 9470 <https://www.rfc-editor.org/rfc/rfc9470>
 *
 * Common ACR values for OAuth2 providers include:
 *   - "urn:okta:loa:1fa:any" (okta)
 *   - "urn:okta:loa:1fa:pwd" (okta)
 *   - "urn:okta:loa:2fa:any" (okta)
 *   - "urn:okta:loa:2fa:any:ifpossible" (okta)
 *   - "phr" (okta)
 *   - "phrh" (okta)
 *
 * @generated from protobuf message c1.api.stepup.v1.StepUpOAuth2Settings
 */
export interface StepUpOAuth2Settings {
    /**
     * @generated from protobuf field: repeated string acr_values = 1;
     */
    acrValues: string[];
}
/**
 * StepUpMicrosoftSettings represents a Microsoft Entra Provider using Conditional Access Policies to enforce step-up authentication.
 *
 * @generated from protobuf message c1.api.stepup.v1.StepUpMicrosoftSettings
 */
export interface StepUpMicrosoftSettings {
    /**
     * @generated from protobuf field: repeated string conditional_access_ids = 1;
     */
    conditionalAccessIds: string[];
    /**
     * @generated from protobuf field: string tenant = 2;
     */
    tenant: string;
}
/**
 * @generated from protobuf message c1.api.stepup.v1.ListStepUpProvidersRequest
 */
export interface ListStepUpProvidersRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.stepup.v1.ListStepUpProvidersResponse
 */
export interface ListStepUpProvidersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.stepup.v1.StepUpProvider list = 1;
     */
    list: StepUpProvider[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.stepup.v1.GetStepUpProviderRequest
 */
export interface GetStepUpProviderRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.stepup.v1.GetStepUpProviderResponse
 */
export interface GetStepUpProviderResponse {
    /**
     * @generated from protobuf field: c1.api.stepup.v1.StepUpProvider step_up_provider = 1;
     */
    stepUpProvider?: StepUpProvider;
}
/**
 * @generated from protobuf message c1.api.stepup.v1.CreateStepUpProviderRequest
 */
export interface CreateStepUpProviderRequest {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string issuer_url = 2;
     */
    issuerUrl: string;
    /**
     * @generated from protobuf field: string client_id = 3;
     */
    clientId: string;
    /**
     * @generated from protobuf field: string client_secret = 4;
     */
    clientSecret: string;
    /**
     * @generated from protobuf oneof: settings
     */
    settings: {
        oneofKind: "oauth2";
        /**
         * @generated from protobuf field: c1.api.stepup.v1.StepUpOAuth2Settings oauth2 = 101;
         */
        oauth2: StepUpOAuth2Settings;
    } | {
        oneofKind: "microsoft";
        /**
         * @generated from protobuf field: c1.api.stepup.v1.StepUpMicrosoftSettings microsoft = 102;
         */
        microsoft: StepUpMicrosoftSettings;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.stepup.v1.CreateStepUpProviderResponse
 */
export interface CreateStepUpProviderResponse {
    /**
     * @generated from protobuf field: c1.api.stepup.v1.StepUpProvider step_up_provider = 1;
     */
    stepUpProvider?: StepUpProvider;
}
/**
 * @generated from protobuf message c1.api.stepup.v1.UpdateStepUpProviderRequest
 */
export interface UpdateStepUpProviderRequest {
    /**
     * @generated from protobuf field: c1.api.stepup.v1.StepUpProvider step_up_provider = 1;
     */
    stepUpProvider?: StepUpProvider;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.stepup.v1.UpdateStepUpProviderResponse
 */
export interface UpdateStepUpProviderResponse {
    /**
     * @generated from protobuf field: c1.api.stepup.v1.StepUpProvider step_up_provider = 1;
     */
    stepUpProvider?: StepUpProvider;
}
/**
 * @generated from protobuf message c1.api.stepup.v1.UpdateStepUpProviderSecretRequest
 */
export interface UpdateStepUpProviderSecretRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string client_secret = 2;
     */
    clientSecret: string;
}
/**
 * @generated from protobuf message c1.api.stepup.v1.UpdateStepUpProviderSecretResponse
 */
export interface UpdateStepUpProviderSecretResponse {
    /**
     * @generated from protobuf field: c1.api.stepup.v1.StepUpProvider step_up_provider = 1;
     */
    stepUpProvider?: StepUpProvider;
}
/**
 * @generated from protobuf message c1.api.stepup.v1.DeleteStepUpProviderRequest
 */
export interface DeleteStepUpProviderRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.stepup.v1.DeleteStepUpProviderResponse
 */
export interface DeleteStepUpProviderResponse {
}
/**
 * @generated from protobuf message c1.api.stepup.v1.TestStepUpProviderRequest
 */
export interface TestStepUpProviderRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.stepup.v1.TestStepUpProviderResponse
 */
export interface TestStepUpProviderResponse {
    /**
     * The URL to redirect the user to for testing the Step Up flow
     *
     * @generated from protobuf field: string redirect_url = 1;
     */
    redirectUrl: string;
}
/**
 * Request message for retrieving a specific step-up transaction
 *
 * @generated from protobuf message c1.api.stepup.v1.GetStepUpTransactionRequest
 */
export interface GetStepUpTransactionRequest {
    /**
     * ID of the transaction to retrieve
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * Response message containing the requested step-up transaction
 *
 * @generated from protobuf message c1.api.stepup.v1.GetStepUpTransactionResponse
 */
export interface GetStepUpTransactionResponse {
    /**
     * The requested transaction
     *
     * @generated from protobuf field: c1.api.stepup.v1.StepUpTransaction transaction = 1;
     */
    transaction?: StepUpTransaction;
}
/**
 * Request message for searching step-up transactions
 *
 * @generated from protobuf message c1.api.stepup.v1.SearchStepUpTransactionsRequest
 */
export interface SearchStepUpTransactionsRequest {
    /**
     * Maximum number of results to return
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * Token for pagination
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Filter by provider ID
     *
     * @generated from protobuf field: string provider_id = 3;
     */
    providerId: string;
    /**
     * Filter by user ID
     *
     * @generated from protobuf field: string user_id = 4;
     */
    userId: string;
    /**
     * Filter by transaction state
     *
     * @generated from protobuf field: c1.api.stepup.v1.StepUpTransactionState state = 5;
     */
    state: StepUpTransactionState;
    /**
     * @generated from protobuf field: c1.api.stepup.v1.SearchStepUpTransactionsRequest.TargetType target_type = 6;
     */
    targetType: SearchStepUpTransactionsRequest_TargetType;
    /**
     * Filter by task ID (only applicable if target_type is TICKET)
     *
     * @generated from protobuf field: string task_id = 7;
     */
    taskId: string;
    /**
     * Filter by time range - start time
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_after = 8;
     */
    createdAfter?: Timestamp;
    /**
     * Filter by time range - end time
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_before = 9;
     */
    createdBefore?: Timestamp;
}
/**
 * Filter by target type
 *
 * @generated from protobuf enum c1.api.stepup.v1.SearchStepUpTransactionsRequest.TargetType
 */
export enum SearchStepUpTransactionsRequest_TargetType {
    /**
     * @generated from protobuf enum value: TARGET_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TARGET_TYPE_TICKET = 1;
     */
    TICKET = 1,
    /**
     * @generated from protobuf enum value: TARGET_TYPE_TEST = 2;
     */
    TEST = 2
}
/**
 * Response message for searching step-up transactions
 *
 * @generated from protobuf message c1.api.stepup.v1.SearchStepUpTransactionsResponse
 */
export interface SearchStepUpTransactionsResponse {
    /**
     * List of transactions matching the search criteria
     *
     * @generated from protobuf field: repeated c1.api.stepup.v1.StepUpTransaction list = 1;
     */
    list: StepUpTransaction[];
    /**
     * Token for retrieving the next page of results
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * StepUpTransaction represents a record of a step-up authentication attempt
 *
 * @generated from protobuf message c1.api.stepup.v1.StepUpTransaction
 */
export interface StepUpTransaction {
    /**
     * Unique identifier for the transaction
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * ID of the provider used for this step-up authentication
     *
     * @generated from protobuf field: string provider_id = 2;
     */
    providerId: string;
    /**
     * ID of the user who performed the step-up authentication
     *
     * @generated from protobuf field: string user_id = 3;
     */
    userId: string;
    /**
     * When the transaction was created
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * When the transaction was last updated
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * When the transaction expires
     *
     * @generated from protobuf field: google.protobuf.Timestamp expires_at = 6;
     */
    expiresAt?: Timestamp;
    /**
     * Current state of the transaction
     *
     * @generated from protobuf field: c1.api.stepup.v1.StepUpTransactionState state = 7;
     */
    state: StepUpTransactionState;
    /**
     * Error message if the transaction failed
     *
     * @generated from protobuf field: string error_message = 8;
     */
    errorMessage: string;
    /**
     * Claims from the provider on a successful step-up
     *
     * @generated from protobuf field: google.protobuf.Struct claims = 9;
     */
    claims?: Struct;
    /**
     * @generated from protobuf oneof: target
     */
    target: {
        oneofKind: "approveTask";
        /**
         * For approving a task
         *
         * @generated from protobuf field: c1.api.stepup.v1.StepUpTransaction.TargetTask approve_task = 100;
         */
        approveTask: StepUpTransaction_TargetTask;
    } | {
        oneofKind: "test";
        /**
         * For testing a provider
         *
         * @generated from protobuf field: c1.api.stepup.v1.StepUpTransaction.TargetTest test = 101;
         */
        test: StepUpTransaction_TargetTest;
    } | {
        oneofKind: undefined;
    };
}
/**
 * Target for approving a task
 *
 * @generated from protobuf message c1.api.stepup.v1.StepUpTransaction.TargetTask
 */
export interface StepUpTransaction_TargetTask {
    /**
     * ID of the task being approved
     *
     * @generated from protobuf field: string task_id = 1;
     */
    taskId: string;
    /**
     * ID of the policy step requiring step-up authentication
     *
     * @generated from protobuf field: string policy_step_id = 2;
     */
    policyStepId: string;
}
/**
 * Target for testing a provider
 *
 * No additional fields needed for test transactions
 *
 * @generated from protobuf message c1.api.stepup.v1.StepUpTransaction.TargetTest
 */
export interface StepUpTransaction_TargetTest {
}
/**
 * Request message for searching step-up providers
 *
 * @generated from protobuf message c1.api.stepup.v1.SearchStepUpProvidersRequest
 */
export interface SearchStepUpProvidersRequest {
    /**
     * Maximum number of results to return
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * Token for pagination
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.stepup.v1.SearchStepUpProvidersRequest.ProviderType provider_type = 3;
     */
    providerType: SearchStepUpProvidersRequest_ProviderType;
    /**
     * Filter by name (partial match)
     *
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.stepup.v1.StepUpProviderRef refs = 33;
     */
    refs: StepUpProviderRef[];
}
/**
 * Filter by provider type
 *
 * @generated from protobuf enum c1.api.stepup.v1.SearchStepUpProvidersRequest.ProviderType
 */
export enum SearchStepUpProvidersRequest_ProviderType {
    /**
     * @generated from protobuf enum value: PROVIDER_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PROVIDER_TYPE_OAUTH2 = 1;
     */
    OAUTH2 = 1,
    /**
     * @generated from protobuf enum value: PROVIDER_TYPE_MICROSOFT = 2;
     */
    MICROSOFT = 2
}
/**
 * Response message for searching step-up providers
 *
 * @generated from protobuf message c1.api.stepup.v1.SearchStepUpProvidersResponse
 */
export interface SearchStepUpProvidersResponse {
    /**
     * List of providers matching the search criteria
     *
     * @generated from protobuf field: repeated c1.api.stepup.v1.StepUpProvider list = 1;
     */
    list: StepUpProvider[];
    /**
     * Token for retrieving the next page of results
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * State of a step-up transaction
 *
 * @generated from protobuf enum c1.api.stepup.v1.StepUpTransactionState
 */
export enum StepUpTransactionState {
    /**
     * Default unspecified state
     *
     * @generated from protobuf enum value: STEP_UP_TRANSACTION_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Transaction has been created but authentication is not complete
     *
     * @generated from protobuf enum value: STEP_UP_TRANSACTION_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * Authentication was successful
     *
     * @generated from protobuf enum value: STEP_UP_TRANSACTION_STATE_VERIFIED = 2;
     */
    VERIFIED = 2,
    /**
     * Authentication failed
     *
     * @generated from protobuf enum value: STEP_UP_TRANSACTION_STATE_ERROR = 3;
     */
    ERROR = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class StepUpProviderRef$Type extends MessageType<StepUpProviderRef> {
    constructor() {
        super("c1.api.stepup.v1.StepUpProviderRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.StepUpProviderRef
 */
export const StepUpProviderRef = new StepUpProviderRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StepUpProvider$Type extends MessageType<StepUpProvider> {
    constructor() {
        super("c1.api.stepup.v1.StepUpProvider", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "64" } } } },
            { no: 3, name: "issuer_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "1024", uri: true } } } },
            { no: 4, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "1024" } } } },
            { no: 5, name: "enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "last_tested_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 101, name: "oauth2", kind: "message", oneof: "settings", T: () => StepUpOAuth2Settings },
            { no: 102, name: "microsoft", kind: "message", oneof: "settings", T: () => StepUpMicrosoftSettings }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.StepUpProvider
 */
export const StepUpProvider = new StepUpProvider$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StepUpOAuth2Settings$Type extends MessageType<StepUpOAuth2Settings> {
    constructor() {
        super("c1.api.stepup.v1.StepUpOAuth2Settings", [
            { no: 1, name: "acr_values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "10", unique: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.StepUpOAuth2Settings
 */
export const StepUpOAuth2Settings = new StepUpOAuth2Settings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StepUpMicrosoftSettings$Type extends MessageType<StepUpMicrosoftSettings> {
    constructor() {
        super("c1.api.stepup.v1.StepUpMicrosoftSettings", [
            { no: 1, name: "conditional_access_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "10", unique: true, items: { string: { pattern: "^C([1-9]|[1-9][0-9])$" } } } } } },
            { no: 2, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.StepUpMicrosoftSettings
 */
export const StepUpMicrosoftSettings = new StepUpMicrosoftSettings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStepUpProvidersRequest$Type extends MessageType<ListStepUpProvidersRequest> {
    constructor() {
        super("c1.api.stepup.v1.ListStepUpProvidersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.ListStepUpProvidersRequest
 */
export const ListStepUpProvidersRequest = new ListStepUpProvidersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListStepUpProvidersResponse$Type extends MessageType<ListStepUpProvidersResponse> {
    constructor() {
        super("c1.api.stepup.v1.ListStepUpProvidersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StepUpProvider },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.ListStepUpProvidersResponse
 */
export const ListStepUpProvidersResponse = new ListStepUpProvidersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStepUpProviderRequest$Type extends MessageType<GetStepUpProviderRequest> {
    constructor() {
        super("c1.api.stepup.v1.GetStepUpProviderRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.GetStepUpProviderRequest
 */
export const GetStepUpProviderRequest = new GetStepUpProviderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStepUpProviderResponse$Type extends MessageType<GetStepUpProviderResponse> {
    constructor() {
        super("c1.api.stepup.v1.GetStepUpProviderResponse", [
            { no: 1, name: "step_up_provider", kind: "message", T: () => StepUpProvider }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.GetStepUpProviderResponse
 */
export const GetStepUpProviderResponse = new GetStepUpProviderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStepUpProviderRequest$Type extends MessageType<CreateStepUpProviderRequest> {
    constructor() {
        super("c1.api.stepup.v1.CreateStepUpProviderRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "64" } } } },
            { no: 2, name: "issuer_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "1024", uri: true } } } },
            { no: 3, name: "client_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "1024" } } } },
            { no: 4, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "2048" } } } },
            { no: 101, name: "oauth2", kind: "message", oneof: "settings", T: () => StepUpOAuth2Settings },
            { no: 102, name: "microsoft", kind: "message", oneof: "settings", T: () => StepUpMicrosoftSettings }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.CreateStepUpProviderRequest
 */
export const CreateStepUpProviderRequest = new CreateStepUpProviderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateStepUpProviderResponse$Type extends MessageType<CreateStepUpProviderResponse> {
    constructor() {
        super("c1.api.stepup.v1.CreateStepUpProviderResponse", [
            { no: 1, name: "step_up_provider", kind: "message", T: () => StepUpProvider }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.CreateStepUpProviderResponse
 */
export const CreateStepUpProviderResponse = new CreateStepUpProviderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStepUpProviderRequest$Type extends MessageType<UpdateStepUpProviderRequest> {
    constructor() {
        super("c1.api.stepup.v1.UpdateStepUpProviderRequest", [
            { no: 1, name: "step_up_provider", kind: "message", T: () => StepUpProvider },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.UpdateStepUpProviderRequest
 */
export const UpdateStepUpProviderRequest = new UpdateStepUpProviderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStepUpProviderResponse$Type extends MessageType<UpdateStepUpProviderResponse> {
    constructor() {
        super("c1.api.stepup.v1.UpdateStepUpProviderResponse", [
            { no: 1, name: "step_up_provider", kind: "message", T: () => StepUpProvider }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.UpdateStepUpProviderResponse
 */
export const UpdateStepUpProviderResponse = new UpdateStepUpProviderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStepUpProviderSecretRequest$Type extends MessageType<UpdateStepUpProviderSecretRequest> {
    constructor() {
        super("c1.api.stepup.v1.UpdateStepUpProviderSecretRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "client_secret", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "2048" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.UpdateStepUpProviderSecretRequest
 */
export const UpdateStepUpProviderSecretRequest = new UpdateStepUpProviderSecretRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateStepUpProviderSecretResponse$Type extends MessageType<UpdateStepUpProviderSecretResponse> {
    constructor() {
        super("c1.api.stepup.v1.UpdateStepUpProviderSecretResponse", [
            { no: 1, name: "step_up_provider", kind: "message", T: () => StepUpProvider }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.UpdateStepUpProviderSecretResponse
 */
export const UpdateStepUpProviderSecretResponse = new UpdateStepUpProviderSecretResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteStepUpProviderRequest$Type extends MessageType<DeleteStepUpProviderRequest> {
    constructor() {
        super("c1.api.stepup.v1.DeleteStepUpProviderRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.DeleteStepUpProviderRequest
 */
export const DeleteStepUpProviderRequest = new DeleteStepUpProviderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteStepUpProviderResponse$Type extends MessageType<DeleteStepUpProviderResponse> {
    constructor() {
        super("c1.api.stepup.v1.DeleteStepUpProviderResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.DeleteStepUpProviderResponse
 */
export const DeleteStepUpProviderResponse = new DeleteStepUpProviderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestStepUpProviderRequest$Type extends MessageType<TestStepUpProviderRequest> {
    constructor() {
        super("c1.api.stepup.v1.TestStepUpProviderRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.TestStepUpProviderRequest
 */
export const TestStepUpProviderRequest = new TestStepUpProviderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TestStepUpProviderResponse$Type extends MessageType<TestStepUpProviderResponse> {
    constructor() {
        super("c1.api.stepup.v1.TestStepUpProviderResponse", [
            { no: 1, name: "redirect_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.TestStepUpProviderResponse
 */
export const TestStepUpProviderResponse = new TestStepUpProviderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStepUpTransactionRequest$Type extends MessageType<GetStepUpTransactionRequest> {
    constructor() {
        super("c1.api.stepup.v1.GetStepUpTransactionRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.GetStepUpTransactionRequest
 */
export const GetStepUpTransactionRequest = new GetStepUpTransactionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStepUpTransactionResponse$Type extends MessageType<GetStepUpTransactionResponse> {
    constructor() {
        super("c1.api.stepup.v1.GetStepUpTransactionResponse", [
            { no: 1, name: "transaction", kind: "message", T: () => StepUpTransaction }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.GetStepUpTransactionResponse
 */
export const GetStepUpTransactionResponse = new GetStepUpTransactionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStepUpTransactionsRequest$Type extends MessageType<SearchStepUpTransactionsRequest> {
    constructor() {
        super("c1.api.stepup.v1.SearchStepUpTransactionsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "provider_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 5, name: "state", kind: "enum", T: () => ["c1.api.stepup.v1.StepUpTransactionState", StepUpTransactionState, "STEP_UP_TRANSACTION_STATE_"], options: { "validate.rules": { enum: { definedOnly: true } } } },
            { no: 6, name: "target_type", kind: "enum", T: () => ["c1.api.stepup.v1.SearchStepUpTransactionsRequest.TargetType", SearchStepUpTransactionsRequest_TargetType, "TARGET_TYPE_"], options: { "validate.rules": { enum: { definedOnly: true } } } },
            { no: 7, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 8, name: "created_after", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false } } } },
            { no: 9, name: "created_before", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: false } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.SearchStepUpTransactionsRequest
 */
export const SearchStepUpTransactionsRequest = new SearchStepUpTransactionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStepUpTransactionsResponse$Type extends MessageType<SearchStepUpTransactionsResponse> {
    constructor() {
        super("c1.api.stepup.v1.SearchStepUpTransactionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StepUpTransaction },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.SearchStepUpTransactionsResponse
 */
export const SearchStepUpTransactionsResponse = new SearchStepUpTransactionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StepUpTransaction$Type extends MessageType<StepUpTransaction> {
    constructor() {
        super("c1.api.stepup.v1.StepUpTransaction", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "provider_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "expires_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "state", kind: "enum", T: () => ["c1.api.stepup.v1.StepUpTransactionState", StepUpTransactionState, "STEP_UP_TRANSACTION_STATE_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 9, name: "claims", kind: "message", T: () => Struct },
            { no: 100, name: "approve_task", kind: "message", oneof: "target", T: () => StepUpTransaction_TargetTask },
            { no: 101, name: "test", kind: "message", oneof: "target", T: () => StepUpTransaction_TargetTest }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.StepUpTransaction
 */
export const StepUpTransaction = new StepUpTransaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StepUpTransaction_TargetTask$Type extends MessageType<StepUpTransaction_TargetTask> {
    constructor() {
        super("c1.api.stepup.v1.StepUpTransaction.TargetTask", [
            { no: 1, name: "task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "policy_step_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.StepUpTransaction.TargetTask
 */
export const StepUpTransaction_TargetTask = new StepUpTransaction_TargetTask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StepUpTransaction_TargetTest$Type extends MessageType<StepUpTransaction_TargetTest> {
    constructor() {
        super("c1.api.stepup.v1.StepUpTransaction.TargetTest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.StepUpTransaction.TargetTest
 */
export const StepUpTransaction_TargetTest = new StepUpTransaction_TargetTest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStepUpProvidersRequest$Type extends MessageType<SearchStepUpProvidersRequest> {
    constructor() {
        super("c1.api.stepup.v1.SearchStepUpProvidersRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "provider_type", kind: "enum", T: () => ["c1.api.stepup.v1.SearchStepUpProvidersRequest.ProviderType", SearchStepUpProvidersRequest_ProviderType, "PROVIDER_TYPE_"], options: { "validate.rules": { enum: { definedOnly: true } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { maxBytes: "1024" } } } },
            { no: 33, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StepUpProviderRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.SearchStepUpProvidersRequest
 */
export const SearchStepUpProvidersRequest = new SearchStepUpProvidersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStepUpProvidersResponse$Type extends MessageType<SearchStepUpProvidersResponse> {
    constructor() {
        super("c1.api.stepup.v1.SearchStepUpProvidersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => StepUpProvider },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.stepup.v1.SearchStepUpProvidersResponse
 */
export const SearchStepUpProvidersResponse = new SearchStepUpProvidersResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.stepup.v1.StepUpProviderService
 */
export const StepUpProviderService = new ServiceType("c1.api.stepup.v1.StepUpProviderService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/step-up/providers", group: "Step Up Authentication Providers" }] } }, I: ListStepUpProvidersRequest, O: ListStepUpProvidersResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/step-up/providers/{id}", group: "Step Up Authentication Providers" }] } }, I: GetStepUpProviderRequest, O: GetStepUpProviderResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/step-up/providers", group: "Step Up Authentication Providers" }] } }, I: SearchStepUpProvidersRequest, O: SearchStepUpProvidersResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/step-up/providers", group: "Step Up Authentication Providers" }] } }, I: CreateStepUpProviderRequest, O: CreateStepUpProviderResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/step-up/providers/{step_up_provider.id}", group: "Step Up Authentication Providers" }] } }, I: UpdateStepUpProviderRequest, O: UpdateStepUpProviderResponse },
    { name: "UpdateSecret", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/step-up/providers/{id}/secret", group: "Step Up Authentication Providers" }] } }, I: UpdateStepUpProviderSecretRequest, O: UpdateStepUpProviderSecretResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/step-up/providers/{id}", group: "Step Up Authentication Providers" }] } }, I: DeleteStepUpProviderRequest, O: DeleteStepUpProviderResponse },
    { name: "Test", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/step-up/providers/{id}/test", group: "Step Up Authentication Providers" }] } }, I: TestStepUpProviderRequest, O: TestStepUpProviderResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.stepup.v1.StepUpTransactionService
 */
export const StepUpTransactionService = new ServiceType("c1.api.stepup.v1.StepUpTransactionService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/step-up/transactions/{id}", group: "Step Up Authentication Transactions" }] } }, I: GetStepUpTransactionRequest, O: GetStepUpTransactionResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/step-up/transactions", group: "Step Up Authentication Transactions" }] } }, I: SearchStepUpTransactionsRequest, O: SearchStepUpTransactionsResponse }
]);
